// extracted by mini-css-extract-plugin
export default {"melodyVideo":"aL-z","isFullWidth":"bL-z","landingPageVideo":"cL-z","play":"dL-z","iframeVideo":"eL-z","playHidden":"fL-z","fullwidth":"gL-z"};